import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private canGoBack: boolean = false;

  constructor() { }

  getCanGoBack(): boolean {
    return this.canGoBack;
  }

  setCanGoBack(canGoBack: boolean) {
    this.canGoBack = canGoBack;
  }
}
